import { useEffect, useState } from "react";
import { AuthInterceptor } from "../../services/AuthInterceptor.Service";

export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Debounced search over active tests or packages (`kind` = "test" | "package").
 * Runs only while `enabled`; returns { results, searching }.
 */
const useCatalogSearch = (kind, search, enabled = true) => {
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      setSearching(true);
      const response = await AuthInterceptor(
        `/admin/${kind}?page=1&limit=20&isActive=true&search=${encodeURIComponent(search.trim())}`,
        { method: "GET" }
      );
      if (cancelled) return;
      setResults(Array.isArray(response?.data?.r) ? response.data.r : []);
      setSearching(false);
    }, SEARCH_DEBOUNCE_MS);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [kind, search, enabled]);

  return { results, searching };
};

export default useCatalogSearch;
